import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { useFramerAnimation } from '../../hooks';

const StyledContainer = styled(motion.div)`
  background-color: ${(props) => props.$bgColor};

  & h2 {
    color: ${(props) => props.$h2Color} !important;
    &:hover {
      color: ${(props) => props.$h2ColorHover} !important;
    }
  }
  & h3 {
    color: ${(props) => props.$h3Color} !important;
    &:hover {
      color: ${(props) => props.$h3ColorHover} !important;
    }
    & span {
      color: ${(props) => props.$spanColor} !important;
    }
  }
`;

const Container = ({
  padding,
  children,
  classes,
  bgColor,
  h2Color,
  h3Color,
  h3ColorHover,
  spanColor,
  outerClasses,
  disableAnimations,
  animationDelay, // NEW prop
}) => {
  const { variants, controls, ref } = useFramerAnimation({
    initial: disableAnimations ? {} : { opacity: 0, scale: 0.9 },
    animate: disableAnimations ? {} : { opacity: 1, scale: 1 },
    transition: {
      duration: 0.6,
      ease: 'easeOut',
      delay: animationDelay || 0, // use the passed delay if provided
    },
    inViewConfig: { once: true, margin: '75% 75%' },
    disableAnimations,
  });

  const paddingClasses =
    {
      none: 'mx-auto w-full lg:px-0',
      sm: 'mx-auto max-w-7xl px-4 sm:px-6 lg:px-8',
      lg: 'mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 max-w-3xl',
      breaks: 'container mx-auto px-4 sm:px-6 lg:px-8',
      default: 'mx-auto sm:px-6 lg:px-8',
    }[padding] || 'mx-auto sm:px-6 lg:px-8';

  return (
    <StyledContainer
      ref={ref}
      variants={variants}
      initial="initial"
      animate={controls}
      $bgColor={bgColor}
      $h2Color={h2Color}
      $h3Color={h3Color}
      $h3ColorHover={h3ColorHover}
      $spanColor={spanColor}
      className={`${outerClasses}`}
    >
      <div className={`${paddingClasses} ${classes}`}>{children}</div>
    </StyledContainer>
  );
};

Container.defaultProps = {
  padding: 'sm',
  classes: '',
  disableAnimations: false,
  animationDelay: 0, // NEW default prop
};

Container.propTypes = {
  padding: PropTypes.string,
  classes: PropTypes.string,
  children: PropTypes.node.isRequired,
  disableAnimations: PropTypes.bool,
  animationDelay: PropTypes.number, // NEW prop type
};

export { Container };
